module.exports = __webpack_public_path__ + "img/x.04b6012b.svg";